import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inward from "@/pages/Inward";
import Outward from "@/pages/Outward";
import Transfer from "@/pages/Transfer";
import Stacks from "@/pages/Stacks";
import Lots from "@/pages/Lots";
import Parties from "@/pages/Parties";
import Rent from "@/pages/Rent";
import Payments from "@/pages/Payments";
import ManagerCash from "@/pages/ManagerCash";
import Registers from "@/pages/Registers";
import Onboard from "@/pages/Onboard";
import Masters from "@/pages/Masters";
import { Loader2 } from "lucide-react";

function Protected({ path, children }) {
  const { user, canPage } = useAuth();
  if (user === null)
    return (
      <div className="grid min-h-screen place-items-center bg-stone-50">
        <Loader2 className="animate-spin text-emerald-700" size={32} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (path && !canPage(path)) {
    return (
      <Layout>
        <div className="grid min-h-[60vh] place-items-center">
          <div className="max-w-md rounded-xl border border-stone-200 bg-white p-8 text-center shadow-sm">
            <div className="font-display text-xl font-bold text-stone-900">Access denied</div>
            <p className="mt-2 text-sm text-stone-500">
              Your role ({user.role}) cannot open this page.
            </p>
            <a href="/" className="mt-4 inline-block rounded-lg bg-emerald-800 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-900">
              Go to Dashboard
            </a>
          </div>
        </div>
      </Layout>
    );
  }
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected path="/"><Dashboard /></Protected>} />
            <Route path="/inward" element={<Protected path="/inward"><Inward /></Protected>} />
            <Route path="/outward" element={<Protected path="/outward"><Outward /></Protected>} />
            <Route path="/transfer" element={<Protected path="/transfer"><Transfer /></Protected>} />
            <Route path="/stacks" element={<Protected path="/stacks"><Stacks /></Protected>} />
            <Route path="/lots" element={<Protected path="/lots"><Lots /></Protected>} />
            <Route path="/parties" element={<Protected path="/parties"><Parties /></Protected>} />
            <Route path="/rent" element={<Protected path="/rent"><Rent /></Protected>} />
            <Route path="/payments" element={<Protected path="/payments"><Payments /></Protected>} />
            <Route path="/cash" element={<Protected path="/cash"><ManagerCash /></Protected>} />
            <Route path="/registers" element={<Protected path="/registers"><Registers /></Protected>} />
            <Route path="/onboard" element={<Protected path="/onboard"><Onboard /></Protected>} />
            <Route path="/masters" element={<Protected path="/masters"><Masters /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
